import styled from 'styled-components'
import { theme } from 'styles/theme'

import { Box } from '../Box'

export const ModalsBackground = styled.div<{ $visible: boolean }>(({ $visible }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.black,
  opacity: $visible ? 0.75 : 0,
  transition: `opacity ${theme.transition.duration}ms ${theme.transition.easing}`,
  pointerEvents: $visible ? 'auto' : 'none',
}))

export const ModalsContainer = styled.div({
  zIndex: 100,
})

export const ModalsContainerWrapper = styled.div<{ size: 'small' | 'normal' }>(({ size }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  pointerEvents: 'none',
  [theme.mediaQueries.medium]: {
    inset: '50% auto auto 50%',
    transform: 'translate(-50%, -50%) scale(1)',
    'border-radius': '16px',
    'min-width': size === 'normal' ? '50vw' : 'auto',
    'max-height': '100vh',
  },
}))

export const ModalContainer = styled(Box)<{ $visible: boolean; customPaddingTop?: number }>(
  ({ $visible, width, size, customPaddingTop }) => ({
    opacity: $visible ? 1 : 0,
    transition: `opacity ${theme.transition.duration}ms ${theme.transition.easing}`,
    backgroundColor: 'var(--background)',
    color: 'var(--foreground)',
    pointerEvents: 'initial',
    display: 'flex',
    width: `${width}px`,
    padding: `${customPaddingTop ? `${customPaddingTop}px 15px 15px` : '15px'}`,
    'min-height': '200px',
    flexDirection: 'column',
    overflowY: 'auto',
    'box-shadow':
      '0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%)',
    height: '100vh',
    '-webkit-transform': 'translate3d(0,0,0) ',
    transform: 'translate3d(0,0,0) ',
    [theme.mediaQueries.medium]: {
      'min-width': size === 'normal' ? '50vw' : 'auto',
      'max-height': '90vh',
      height: '100%',
      borderRadius: 16,
    },
  })
)
